module.exports = __webpack_public_path__ + "img/kkb_QLB30.b5ba6627.jpg";